// extracted by mini-css-extract-plugin
export default {"vendorHeader":"vendorHeader__OGYyZ","hed":"hed__MDg5M","vendor":"vendor__NTNjY","info":"info__NDRlY","name":"name__ZWU2N"};